import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { PageDS, ToastContainerDS, TabMenu } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import "../../i18n/i18n";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  selectCompaniesListStatus,
  companiesListAsync,
} from "../companiesSlice";
import {
  badgesReturnedListAsync,
  selectBadgesReturnedListStatus,
} from "./badgesSlice";
import { BadgesReturnedTab } from "./badgesReturnedTab";

export const Badges = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useAppDispatch();
  const companiesListStatus = useAppSelector(selectCompaniesListStatus);
  const badgesReturnedListStatus = useAppSelector(
    selectBadgesReturnedListStatus,
  );
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "returned",
  );

  useEffect(() => {
    if (selectedTab) {
      navigate(`/home/badges/${selectedTab}`);
    }
  }, [navigate, selectedTab]);

  useEffect(() => {
    if (companiesListStatus === "idle") {
      void dispatch(companiesListAsync());
    }
  }, [companiesListStatus, dispatch]);

  useEffect(() => {
    if (badgesReturnedListStatus === "idle") {
      void dispatch(badgesReturnedListAsync());
    }
  }, [badgesReturnedListStatus, dispatch]);

  const tabs = useMemo(
    () => [
      {
        name: "returned",
        title: t("badges.tab.returned"),
      },
    ],
    [t],
  );

  return (
    <PageDS
      title={t(`badges.title`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </>
      }
    >
      <BadgesReturnedTab />
    </PageDS>
  );
};
